export default __webpack_public_path__ + "static/media/network_diagram.7682601c.png";